import React from 'react'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap'
import { GenerateRandomNumber, GetUser, UploadBlogPost } from '../../firebase/firebase'
import { useAuth } from '../../contexts/AuthContext'
import Spinner from 'react-spinkit'
export default function CreateBlogPost({ match }) {
    const { path } = match
    const { currentUser, logout, userRole } = useAuth()
    const [user, setUser] = useState('')
    const [loading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    const history = useHistory()
    const [image, setImage] = useState('')
    const newMode = true

    const timeFormat = {
        timeZone: 'America/New_York',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric'
    }



    const [blogPost, setBlogPost] = useState({
        title: "",
        category: '',
        text: '',
        image: '',
        id: '',
        time: Date.now()

    })

    useEffect(() => {
        GetUser(currentUser.uid).then((user) => {
            setUser(user.data())
        })
    }, [])

    const onChange = (e) => {
        setBlogPost({ ...blogPost, [e.target.name]: e.target.value })
        console.log(blogPost)

    }

    const handleCancel = (e) => {
        history.push('/blog')
    }

    const handleSubmit = async (e) => {
        const form = e.currentTarget
        if (form.checkValidity() === false) {
            console.log('need val')
            e.preventDefault()
            e.stopPropagation()
        }
        setValidated(true)
        e.preventDefault()


        try {
            setLoading(true)
            let blogPostToUpload = { ...blogPost }
            blogPostToUpload.id = GenerateRandomNumber()
            blogPostToUpload.imagePath = `/posts/${blogPostToUpload.id}`
            blogPostToUpload.ownerUid = user.id
            blogPostToUpload.creator = user.firstName + ' ' + user.lastName
            blogPostToUpload.likes = 0


            await UploadBlogPost(blogPostToUpload).then((post) => {
                history.push(`/blog/${post.id}`)
            })


        }

        catch (e) {
            alert(`Error " ${e.message}`)

        }
        setLoading(false)
    }


    return (
        <>

            {loading ?
                <Container style={{ top: '0', position: 'absolute' }} fluid className='min-vh-100 d-flex flex-grow-1'>
                    <Row className="justify-content-center flex-grow-1">
                        <Col className='d-flex justify-content-center align-items-center'>
                            <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                        </Col>
                    </Row>
                </Container>
                :
                <Container fluid className='pt-5'>

                    <Row className="justify-content-md-center">
                        <Col lg={6}>
                            <Card>
                                <Form validated={validated} onSubmit={handleSubmit}>
                                    <Card.Header>
                                        Add a Blog Post
                                    </Card.Header>
                                    <Card.Img variant="top" src={image} className='p-3' />
                                    <Form.File
                                        className='mx-5'
                                        type="file"
                                        accept="image/*"
                                        required
                                        onChange={(e) => {
                                            if (e.target.files[0]) {
                                                console.log(e.target.files[0])
                                                setBlogPost({ ...blogPost, ['image']: e.target.files[0] })
                                                setImage(URL.createObjectURL(e.target.files[0]))

                                            }
                                        }}

                                    />
                                    <Card.Body>
                                        <Row className="mb-3">
                                            <Form.Control

                                                onChange={onChange}
                                                type="text"
                                                required
                                                placeholder="Category"
                                                value={blogPost.category}
                                                name='category'
                                            />



                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Control
                                                required
                                                onChange={onChange}
                                                type="text"
                                                placeholder="Title"
                                                value={blogPost.title}
                                                name='title'
                                            />



                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Control
                                                required
                                                as='textarea'
                                                rows={5}
                                                onChange={onChange}
                                                type="text"
                                                placeholder="Text"
                                                value={blogPost.text}
                                                name='text'
                                            />

                                        </Row>
                                        <Row xl={6}>
                                            <Col>
                                                <Button type="submit">Create</Button>
                                            </Col>
                                            <Col>
                                                <Button type='button' variant="secondary" onClick={handleCancel}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>

                                    </Card.Body>
                                </Form>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            }

        </>
    )
}
